import readXlsxFile from 'read-excel-file';
import { generatePassword } from '../utils/parse-server-utils';
import { formatCpf, removeDuplicates } from '../utils/text-processor';

const schema = {
  Nome: {
    prop: 'name',
    type: String,
    required: true
  },
  Cargo: {
    prop: 'course',
    type: String,
    required: true
  },
  Nascimento: {
    prop: 'birthday',
    type: Date,
    required: true
  },
  CPF: {
    prop: 'cpf',
    type: String,
    required: false
  },
  Telefone: {
    prop: 'phone',
    type: String,
    required: false
  },
  Email: {
    prop: 'email',
    type: String,
    required: false
  },
  Area: {
    prop: 'area',
    type: String,
    required: false
  },
  Unidade: {
    prop: 'unit',
    type: String,
    required: false
  },
  Sexo: {
    prop: 'sex',
    type: String,
    required: false
  }
};

async function readAreas(filePath, sheetName = 'AREAS') {
  const areasRowsList = await readXlsxFile(filePath, {
    sheet: 'USERS',
    schema: {
      Area: schema.Area
    }
  });
  const areasRows = removeDuplicates(areasRowsList.rows.map(area => area.area));
  return areasRows;
}
const readCourses = async (filePath, sheetName = 'CARGOS') => {
  console.log(filePath);
  const courseRowsList = await readXlsxFile(filePath, {
    sheet: 'USERS',
    schema: {
      Cargo: schema.Cargo
    }
  });
  const courseRows = removeDuplicates(
    courseRowsList.rows.map(course => course.course)
  );
  return courseRows;
};

async function readUnits(filePath, sheetName = 'UNIDADES') {
  try {
    const unitiesRows = await readXlsxFile(filePath, { sheet: sheetName });
    return unitiesRows;
  } catch {
    return [];
  }
}

async function readUsers(filePath, institution = '') {
  const usersRows = await readXlsxFile(filePath, { schema });
  usersRows.rows.map(user => {
    const userBirthday = new Date(user.birthday);
    user.password = generatePassword(userBirthday);
    user.birthday = `${String(
      userBirthday.getUTCDate() < 10
        ? `0${String(userBirthday.getUTCDate())}`
        : userBirthday.getUTCDate()
    )}/${String(
      userBirthday.getUTCMonth() + 1 < 10
        ? `0${String(userBirthday.getUTCMonth() + 1)}`
        : userBirthday.getUTCMonth() + 1
    )}/${String(userBirthday.getFullYear())}`;
    user.institutionId = institution;
    const cpf = formatCpf(user.cpf);
    user.cpf = cpf;
    user.phone = user.phone ? String(user.phone) : undefined;
    user.username = user.cpf;
  });
  return usersRows.rows;
}
export default { readUsers, readAreas, readCourses, readUnits };
